import * as React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { PrimaryButton, Stack, DefaultButton, TextField } from '@fluentui/react';
import { MutableRefObject } from 'react';

interface ITextEditorProps {
    text: string;
    title: string;
    setText: (text: string) => void;    
    setTitle: (text: string) => void;    
    close: () => void;
}

export const TextEditor: React.FC<ITextEditorProps> = (props) => {
    const editorRef = React.useRef<any>(null);

    const save = () => {
        if (editorRef && editorRef.current) {
            const editor = editorRef.current as any;
            props.setText(editor.getContent());
        }
    };

    React.useEffect(() => {
       
    });


    return (<Stack tokens={{childrenGap: 10 }}>

        <TextField label="Titule/Předmět" value={props.title} onChange={(e, text) => props.setTitle(text ? text:"") } />
        <Editor
        apiKey="w24vi2qvgbot8i5s4cdehkcra5nygyk2oqo02t78ofll0xtl"
        onInit={(evt, editor) => {
            if (editorRef != null) {
                editorRef.current = editor;
            }
         }
        }
        initialValue={props.text}
        init={{
            height: 550,
            menubar: false,
            plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons save',
            toolbar: 'save undo redo | bold italic underline strikethrough | fontfamily fontsize blocks forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',

            font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comfortaa='Comfortaa', serif; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
            language: 'cs',
            content_style: "@import url('https://fonts.googleapis.com/css?family=Comfortaa&display=swap');",
            save_oncancelcallback: function () { alert('Save canceled'); },
            save_onsavecallback: function () { save(); },
             
        }}
        />
        <Stack horizontal horizontalAlign="center" tokens={{ padding: 10, childrenGap:10 }}>
            <DefaultButton primary onClick={() => save()}>Uložit</DefaultButton >
            <DefaultButton onClick={props.close}>Zavřít</DefaultButton >
        </Stack>
     </Stack>
    );
}

//plugins: [
//    'advlist autolink lists link image charmap print preview anchor',
//    'searchreplace visualblocks code fullscreen',
//    'insertdatetime media table paste code help wordcount'
//],
//    toolbar: 'undo redo | formatselect | ' +
//        'bold italic backcolor forecolor | alignleft aligncenter ' +
//        'alignright alignjustify | bullist numlist outdent indent | ' +
//        'removeformat | help',